module.exports = __webpack_public_path__ + "img/music-play.c2f0f2af.png";